import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { MetricaKPI } from '../../types/indicadores';
import { metricasKpiService } from '../../services';

const columns: ResourceColumn<MetricaKPI>[] = [
  { header: "KPI", accessor: "kpi_nome" },
  { header: "Data", accessor: "data_referencia" },
  { header: "Valor medido", accessor: "valor_medido" },
  { header: "Meta", accessor: "valor_meta" },
  { header: "Responsável", accessor: "responsavel_analise" }
];

export const MetricasKpiListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Métricas dos KPIs"
    description="Valores medidos por período."
    columns={columns}
    service={metricasKpiService}
    createPath="/admin/indicadores/metricas-kpi/novo"
      onEdit={(item) => item.id && navigate("/admin/indicadores/metricas-kpi/editar", { state: { record: item } })}
  />
  );
};